import {
  Input,
  Component,
  OnInit,
  Output,
  ElementRef,
  SimpleChanges,
  Renderer2,
  HostBinding,
  EventEmitter,
  OnChanges
} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR, FormControl} from '@angular/forms';

// TODO: Component not working with async calls (or not working with synchronous calls)

@Component({
  selector: 'app-form-autocomplete',
  templateUrl: './form-autocomplete.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: FormAutocompleteComponent,
      multi: true
    }
  ],
  styleUrls: ['./form-autocomplete.component.scss']
})
export class FormAutocompleteComponent implements OnInit, ControlValueAccessor, OnChanges {
  @Input() formControl: FormControl;
  @Input() items: any[];
  @Input() label = '';
  @Input() placeholder = '';
  @Input() displayField = 'name';
  @Input() showNoneOption = false;
  @Input() noneOptionLabel = 'general.actions.none';
  @Input() isDisabled = false;
  @Input() defaultSelection = null;
  @Input() reactive = false;

  @Output() selectionChange = new EventEmitter<any>();

  filteredItems: any[] = [];

  private onChangeCallback: (_: any) => {};
  private onTouchedCallback: (_: any) => {};

  private initialItems: any[];

  @HostBinding('class.reactive') get isReactive() {
    return this.reactive;
  }

  @HostBinding('class.disabled') get disabled() {
    return this.isDisabled;
  }

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2
  ) {
  }

  displayFn(item: any) {
    return item ? item[this.displayField] : '';
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.filteredItems.length === 0) {
      if (this.items.length === 1) {
        this.filteredItems = this.initialItems.filter(item => item[this.displayField].length !== 0);
      } else {
        this.initialItems = this.items.filter(item => item[this.displayField].length !== 0);
        this.filteredItems = this.items.filter(item => item[this.displayField].length !== 0);
      }
    }

    if (this.items.length === 1) {
      // user has typed something in box
      const query = this.items[0];

      if (typeof query === 'string') {
        if (query.length === 0) {
          this.selectionChange.emit(undefined);
          this.doChanges(undefined);
        } else {
          this.filterValues(query);
        }
      }
    }
  }

  writeValue(value) {
    console.log('writeValue called: ', value);
  }

  registerOnChange(fn) {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn) {
    this.onTouchedCallback = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.renderer.setProperty(this.elementRef, 'disabled', isDisabled);
    this.isDisabled = isDisabled;
  }

  private filterValues(input: string) {
    const query = input.toLowerCase();
    const localFilteredItems = this.initialItems.filter(item =>
      item[this.displayField]?.toLowerCase().includes(query)
    );

    this.filteredItems = localFilteredItems;

    if (localFilteredItems.length === 0) {
      this.items = this.initialItems;
    }
  }

  private doChanges(item) {
    if (this.onChangeCallback) {
      this.onChangeCallback(item);
    }
    if (this.onTouchedCallback) {
      this.onTouchedCallback(item);
    }
  }
}
